"use strict";
/*
 * Welcome to your app's main JavaScript file!
 *
 * We recommend including the built version of this JavaScript file
 * (and its CSS file) in your base layout (base.html.twig).
 */
Object.defineProperty(exports, "__esModule", { value: true });
// any CSS you import will output into a single css file (app.css in this case)
require("./styles/app.scss");
require("bootstrap");
var Frontend_1 = require("./Frontend");
Object.defineProperty(window, 'Frontend', { value: new Frontend_1.default() });
